import { useMutation, useQueryCache } from 'react-query';
import { JudgeAPI } from 'api/admin/judge';
import { JUDGES } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useCreateJudge() {
  const queryCache = useQueryCache();

  return useMutation(JudgeAPI.add, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      onSuccess();
      dispatchToast({ message, type: 'success' });
      queryCache.invalidateQueries(JUDGES);
    },
  });
}
